// =============================================================================
// Shared utility functions
// =============================================================================

// Convert paise (smallest unit) to a display string like "Rs. 1,200" or "Rs. 1,200.50"
export function formatRupees(paise, opts = {}) {
  const { showSymbol = true, locale = "en-IN" } = opts;
  const rupees = paise / 100;
  const formatter = new Intl.NumberFormat(locale, {
    style: showSymbol ? "currency" : "decimal",
    currency: "INR",
    minimumFractionDigits: rupees % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(rupees);
}

// Convert rupees (float or integer) to paise (integer)
export function toPaise(rupees) {
  return Math.round(rupees * 100);
}

// Validate Indian PIN code (6 digits, doesn't start with 0)
export function isValidPincode(pin) {
  return /^[1-9]\d{5}$/.test(pin);
}

// Validate Indian mobile number (+91 format or 10-digit)
export function isValidIndianMobile(phone) {
  // Strip spaces, hyphens, and "+"
  const clean = phone.replace(/[\s\-+]/g, "");
  // Match 91XXXXXXXXXX or just 10 digits starting with 6-9
  return /^(91)?[6-9]\d{9}$/.test(clean);
}

// Normalise mobile number to +91XXXXXXXXXX format
export function normaliseIndianMobile(phone) {
  const clean = phone.replace(/[\s\-+]/g, "");
  if (clean.length === 10 && /^[6-9]/.test(clean)) {
    return `+91${clean}`;
  }
  if (clean.length === 12 && clean.startsWith("91")) {
    return `+${clean}`;
  }
  return phone; // Return as-is if we can't normalise
}

// Email validation - basic, not RFC-perfect but good enough for forms
export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

// Calculate verification fee split given the total fee and revenue share %
// Returns { platformPaise, verifierPaise }
export function splitVerificationFee(totalPaise, revenueSharePercent) {
  const verifierPaise = Math.floor((totalPaise * revenueSharePercent) / 100);
  const platformPaise = totalPaise - verifierPaise;
  return { platformPaise, verifierPaise };
}
